@for (option of options(); track option.value) {
  <label class="radio">
    <input
      class="radio__input"
      type="radio"
      [name]="name"
      [value]="option.value"
      [checked]="option.value === value()"
      [disabled]="disabled()"
      (change)="select(option.value)"
      (blur)="touch()"
    />
    <span class="radio__control" aria-hidden="true"></span>
    <span class="radio__label">{{ option.label }}</span>
  </label>
}
